import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import HtlRoomFactor from "./HtlRoomFactor";
import HtlProdTaxEdit from "./HtlProdTaxEdit";

const GET_POST = gql`
  query MyQuery12( $firmSubCode: String!, $prodCode: String!, $firmMainCode: String!) {
    tbl_product(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        prod_code: { _eq: $prodCode }
      }
    ) {
      firm_main_code
      firm_sub_code
      prod_level
      prod_main_grp
      prod_sub_grp
      prod_code
      prod_name
      prod_type
      default_unit
      factor
      trade
      opt_1
      
      active
     
    }
  }
`;

const GET_RCLASS = gql`
  query MyQuery($firmSubCode: String!, $firmMainCode: String! $drctype: String!) {
    tbl_prod_main_grp(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        prod_m_grp_type: { _eq: $drctype },
        
      }
    ) {
      prod_m_grp_code
      prod_m_grp_name
      prod_m_grp_type
      
    }
  }
`;


const GET_RTTYPE = gql`
  query MyQuery($firmSubCode: String!, $firmMainCode: String! $rClassCode: String!, $drttype: String!) {
    tbl_prod_sub_grp(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
       prod_s_grp_type: { _eq: $drttype },
       prod_m_grp_code : { _eq: $rClassCode },
       
      }
    ) {
      prod_m_grp_code
      prod_s_grp_code
      prod_s_grp_name
      prod_s_grp_type
     
    }
  }
`;

const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;


const UPDATE_RTYPE = gql`
mutation UpdateRoomType(
  $firmMainCode: String!
  $firmSubCode: String!
  $prodCode: String!
  $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!
    $totalRoom: String
   
    $active: Boolean!
   
) {
  update_tbl_product(
    where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
        prod_code: { _eq: $prodCode }
    },
    _set: {
      prod_name: $rTypeName,
      prod_sub_grp: $rTypeCode,
      prod_main_grp: $rClassCode,
      default_unit: $rBedType,
      active: $active,
      opt_1: $totalRoom,
     
    }
  ) {
    affected_rows
  }
}
`;

const INSERT_RTYPE = gql`
  mutation InsertRoomType(
    $firmMainCode: String!
    $firmSubCode: String!
    $prodCode: String!
    $rClassCode: String!
    $rTypeCode: String!
    $rTypeName: String!
    $rBedType: String!    
    $active: Boolean
    $prodLevel: String
    $totalRoom: String
  ) {
    insert_tbl_product(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        prod_code: $prodCode,
        prod_main_grp: $rClassCode,
        prod_sub_grp: $rTypeCode,
        prod_name: $rTypeName,
        default_unit: $rBedType,
        active: true,
        prod_level: SUB,
        prod_type: "TPRD",
        opt_1: $totalRoom,
      }
    ) {
      affected_rows
    }
  }
`;



const GET_HTL_RULE = gql`
  query GetHtlSea(
    $firmMainCode: String
    $firmSubCode: String
    $prodCode: String
    
  ) {
    tbl_acc_ent(order_by: { acc_id: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        souce_code: { _eq:  $prodCode }
      
       
      }
    ) {
      firm_main_code
      firm_sub_code
      acc_id
      acc_type
      acc_code
      souce_code
      source_type
      opr_filter
      opr_filter_gnl
      card_value
       
    }
  }
`;

const GET_RULE_SUB = gql`
  query GetRuleSub(
    $firmMainCode: String, 
    $firmSubCode: String,
    $prodCode: String
  ) {
    tbl_acc_ent(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        source_code: { _eq:  $prodCode }
        
      },
      order_by: { acc_id: asc } 
    ) {   
      firm_main_code
      firm_sub_code
      acc_id
      acc_ent_id
      acc_type
      acc_code
      source_code
      source_type
      opr_filter
      opr_filter_gnl
      card_value

    }
  }
`;





const HtlProdStockCardEditDialog = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const { prod_code } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const {varCode3, setVarCode3} = useContext(ThemeContext);
  const {varCode4, setVarCode4} = useContext(ThemeContext);
  const {varCode5, setVarCode5} = useContext(ThemeContext);
  const {varCode6, setVarCode6} = useContext(ThemeContext);
  const {varCode7, setVarCode7} = useContext(ThemeContext);
  const {varCode8, setVarCode8} = useContext(ThemeContext);
  const {varCode9, setVarCode9} = useContext(ThemeContext);
  const {varCode10, setVarCode10} = useContext(ThemeContext);
  const {varCode11, setVarCode11} = useContext(ThemeContext);
  const {varCode12, setVarCode12} = useContext(ThemeContext);
  const {varCode13, setVarCode13} = useContext(ThemeContext);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, prodCode: "" },
  });
  const [UpdateRoomType] = useMutation(UPDATE_RTYPE);
  const [InsertRoomType] = useMutation(INSERT_RTYPE);

  const firmData = data && data.tbl_product ? data.tbl_product[0] : null;



  
  const [rClassName, setRClassName] = useState(firmData ? firmData.r_class_name : "");
  const [rClassCode, setRClassCode] = useState(firmData ? firmData.prod_main_grp : "");
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.prod_sub_grp : "");
  const [prodCode, setProdCode] = useState(firmData ? firmData.prod_code : "");
  const [prodType, setProdType] = useState(firmData ? firmData.prod_type : "");
  const [rTypeName, setRTypeName] = useState(firmData ? firmData.prod_name : "");
  const [rBedType, setRBedType] = useState(firmData ? firmData.default_unit : "");
  const [rBed, setBed] = useState(firmData ? firmData.bed : "");
  const [minPax, setMinPax] = useState(firmData ? firmData.min_pax : "");
  const [maxPax, setMaxPax] = useState(firmData ? firmData.max_pax: "");
  const [minAdl, setMinAdl] = useState(firmData ? firmData.min_adl : "");
  const [maxAdl, setMaxAdl] = useState(firmData ? firmData.max_adl: "");
  const [minChl, setMinChl] = useState(firmData ? firmData.min_chl : "");
  const [maxChl, setMaxChl] = useState(firmData ? firmData.max_chl : "");
  const [totalRoom, setTotalRoom] = useState(firmData ? firmData.opt_1 : "");
  const [babyStart, setBabyStart] = useState(firmData ? firmData.baby_start : "");
  const [babyEnd, setBabyEnd] = useState(firmData ? firmData.baby_end : "");
  const [chlStart, setChlStart] = useState(firmData ? firmData.chl_start : "");
  const [chlEnd, setChlEnd] = useState(firmData ? firmData.chl_end : "");
  const [rIntId, setRIntId] = useState(firmData ? firmData.int_ID : "");
  const [active, setActive] = useState(firmData ? firmData.active : true);
  const [basePricePers, setBasePricePers] = useState(firmData ? firmData.base_price_persent : "");


  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const close_form = messages[currentLocale].close_form;
  
  const typerec = messages[currentLocale].typerec;
  
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const select_a_room_class = messages[currentLocale].select_a_room_class;
  const select_a_room_type = messages[currentLocale].select_a_room_type;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  
 
  const create_room_typerec = messages[currentLocale].create_room_typerec;
  
  const managing_hotel = messages[currentLocale].managing_hotel;
  
  const room_class_tab = messages[currentLocale].room_class_tab;
  const room_type_tab = messages[currentLocale].room_type_tab;
  const room_class_code = messages[currentLocale].room_class_code;
  
  const room_bed_title = messages[currentLocale].room_bed_title;
  const room_bed_type_title = messages[currentLocale].room_bed_type_title;
  const room_total_title = messages[currentLocale].room_total_title;
  const room_max_pax_title = messages[currentLocale].room_max_pax_title;
  const room_min_pax_title = messages[currentLocale].room_min_pax_title;
  const room_chl_max_title = messages[currentLocale].room_chl_max_title;
  const room_chl_min_title = messages[currentLocale].room_chl_min_title;
  const room_baby_start_title = messages[currentLocale].room_baby_start_title;
  const room_baby_end_title = messages[currentLocale].room_baby_end_title;
  const room_chl_start_title = messages[currentLocale].room_chl_start_title;
  const room_chl_end_title = messages[currentLocale].room_chl_end_title;
  

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const room_person_factor_title = messages[currentLocale].room_person_factor_title;
  const room_base_realtion = messages[currentLocale].room_base_realtion;

  

  

  


  
  const { loading: drtLoading, error: drtError, data: drtData } = useQuery(GET_RTTYPE, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, drttype: "SCSG", rClassCode: rClassCode },
  });


  const { loading: drcLoading, error: drcError, data: drcData } = useQuery(GET_RCLASS, {
    variables: {firmSubCode: firmSubCode, firmMainCode: firmMainCode, drctype: "SCMG" },
  });

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "UNIT", lang: currentLocale },
  });

  const roomClassSelectItemsC = drcData && drcData.tbl_prod_main_grp
  ? drcData.tbl_prod_main_grp.map(item => ({
      label: item.prod_m_grp_name,
      value: item.prod_m_grp_code,
      name: item.prod_m_grp_name, 
    }))
  : [];

  const roomClassSelectItems = drtData && drtData.tbl_prod_sub_grp
  ? drtData.tbl_prod_sub_grp.map(item => ({
      label: item.prod_s_grp_name,
      value: item.prod_s_grp_code,
      name: item.prod_s_grp_name, 
    }))
  : [];

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const [displayBasic, setDisplayBasic] = useState(false);
  const [displayBasictax, setDisplayBasictax] = useState(false);

  const onClick = () => {
    setVarCode(rTypeCode);
    setDisplayBasic(true);
    refetch();
  };

  const onHide = () => {
    setDisplayBasic(false);
    refetch();
    
  };

  const onClicktax = () => {
    setVarCode(rTypeCode);
    setVarCode12(prodType);
    setVarCode11(prodCode); 
    setDisplayBasictax(true);
    refetch();
    

  };

  const onClicktax2 = () => {
    setVarCode(rTypeCode);
    setVarCode12(prodType);
    setVarCode11(prodCode); 
    setVarCode13(0);
    setDisplayBasictax(true);
    refetch();
    

  };

  const onHidetax = () => {
    setDisplayBasictax(false);
    refetch();
    refetchRuleSub();
    
  };
  
  

  

  
  

  
  
  
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");  
  
  console.log("Firm Data:", firmData);

  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;

  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };

  const { loading: loadingRuleSub, error: perRuleSubError, data: perRuleSubData, refetch: refetchRuleSub } = useQuery(GET_RULE_SUB, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, prodCode: prodCode },
  });

  const { loading: htlRuleLoading, error: htlRuleError, data: htlRuleData, refetch: refetcGetHtlRule } = useQuery(GET_HTL_RULE, {
    variables: {  firmMainCode: firmMainCode, firmSubCode: firmSubCode, prodCode: prodCode},
  });


  const firmData2 = perRuleSubData && perRuleSubData.tbl_acc_ent;
  

  useEffect(() => {
    if (drtData && drtData.tbl_gnl_def) {
      const selectedRoomClass = drtData.tbl_gnl_def.find(item => item.code === rTypeCode);
      if (selectedRoomClass) {
        setRTypeName(selectedRoomClass.name);
      }
    }
  }, [rTypeCode, drtData]);

  useEffect(() => {
    if (firmData) {
      setRClassName(firmData.r_class_name);
      setRClassCode(firmData.prod_main_grp);
      setRTypeCode(firmData.prod_sub_grp);
      setProdCode(firmData.prod_code);
      setRTypeName(firmData.prod_name);
      setRBedType(firmData.default_unit);
      setProdType(firmData.prod_type);

      
      setBed(firmData.bed);
      setMinPax(firmData.min_pax);
      setMaxPax(firmData.max_pax);
      setMinAdl(firmData.min_adl);
      setMaxAdl(firmData.max_adl);
      setMinChl(firmData.min_chl);
      setMaxChl(firmData.max_chl);
      
      setTotalRoom(firmData.total_room);
      setBabyStart(firmData.baby_start);
      setBabyEnd(firmData.baby_end);
      setChlStart(firmData.chl_start);
      setChlEnd(firmData.chl_end);
      setRIntId(firmData.int_ID);
      setActive(firmData.active);
      setTotalRoom(firmData.opt_1);
      setBasePricePers(firmData.base_price_persent);
      
    }
  }, [firmData]);

  const handleUpdate = () => {
    UpdateRoomType({
      variables: {
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        prodCode: prodCode,
        totalRoom: totalRoom,
       
        active: active,
        

        
      },
    })
      .then(() => {
        window.alert("Room Type updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating Room Type:", error);
      });
  };

  const handleinsert = () => {
    InsertRoomType({
      variables: {
        firmSubCode: firmSubCode,
        firmMainCode: firmMainCode,
        rClassCode: rClassCode,
        rTypeCode: rTypeCode,
        rTypeName: rTypeName,
        rBedType: rBedType,
        prodCode: prodCode,       
        active: active,
        totalRoom: totalRoom
       
        
    
           
      },
    })
      .then(() => {
        window.alert("Firm insert successfully!");
        refetchRuleSub();
        refetcGetHtlRule();

      })
      .catch((error) => {
        console.error("Error insert firm:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;

const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: administrator ,url:"/htl/hotel-adm/main" }, { label: managing_hotel ,url:"/htl/hotel-adm/accomodation/room-type-list" }, { label: managing_hotel }];

return (

  


    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
  

    <div className="mt-0">

    <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
   <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
                {"Product Detail"}
            </span>
          }
          className="ml-5 flex"
        >
  
        
  <div className="container flex-col p-2 mx-auto sm:p-4 dark:text-gray-100">
    

    <div className="flex">
  <div className="mr-2 w-1/6">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Main Code"}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rClassCode}
      onChange={(e) => setRClassCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {room_class_tab}
    </label>
    <Dropdown
      className="h-11  w-56 md:w-56 mr-2 rounded-md"
      style={{ flex: '3' }}
      value={"Main Group"}
      options={roomClassSelectItemsC}
      onChange={(e) => setRClassCode(e.value)}
      placeholder={"Select Main Group"}
    />
  </div>

  <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"Sub Code"}
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={rTypeCode}
      onChange={(e) => setRTypeCode(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
      readOnly
    />
  </div>

  <div>
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Product Sub Name"}
    </label>
    <Dropdown
      className="h-11 w-3/8 rounded-md"
      style={{ flex: '2' }}
      value={rTypeCode}
      options={roomClassSelectItems}
      onChange={(e) => setRTypeCode(e.value)}
      placeholder={select_a_room_type}
    />
  </div>
  <label htmlFor="firmtype" 
  className="mb-2 block font-medium text-gray-950">Status </label><p></p>
  <div className="flex mt-5 ml-0 flex-wrap gap-6">
  <div className="flex ml-0 mt-2 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setActive(e.value)} checked={active === true} />
          <label htmlFor="ingredient1" className="ml-2">Active</label>
          
      </div>
      <div className="flex align-items-center mt-2">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setActive(e.value)} checked={active === false} />
          <label htmlFor="ingredient2" className="ml-2">Inactive</label>
      </div>
      
  </div>

</div>

<div className="flex mb-4">

<div className="mt-4 w-1/6 pr-4">
    <label htmlFor="firmName" className="block font-medium text-gray-700">
      {"Product Code"}
    </label>
    <input
      type="text"
      id="firmName"
      name="firmName"
      value={prodCode}
      onChange={(e) => setProdCode(e.target.value)}
      className="mt-1 px-4 py-2 border w-full border-gray-300 focus:ring-blue-500 focus:border-blue-500 block rounded-md"
    />
  </div>

  <div className="mt-4 w-2/6 pr-4">
    <label htmlFor="firmName" className="block font-medium text-gray-700">
      {"Product Name"}
    </label>
    <input
      type="text"
      id="firmName"
      name="firmName"
      value={rTypeName}
      onChange={(e) => setRTypeName(e.target.value)}
      className="mt-1 px-4 py-2 border w-full border-gray-300 focus:ring-blue-500 focus:border-blue-500 block rounded-md"
    />
  </div>

  <div className="mt-4 w-2/6 pr-4">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Default Unit"}
    </label>
    <Dropdown
      className="w-full rounded-md"
      value={rBedType}
      options={roomClassSelectItemsB}
      onChange={(e) => setRBedType(e.value)}
      placeholder={"Select Default Unit"}
    />
  </div>




  <div className="flex-auto mr-4 ml-2 mt-4 w-2/6">
  <label htmlFor="integeronly" className="font-medium block mb-1">{"Altarnative Name"}</label>
  <InputText
    inputId="integeronly"
    value={totalRoom} 
    onValueChange={(e) => setTotalRoom(e.value)}
    className="w-full h-11  border-gray-300 rounded-md "
  />
</div>
</div>




<div className="grid grid-cols-6">
  <div className="col-span-1">
    <div className="mr-2 inputtext ml-2"> {/* Genişliği 36rem veya uygun bir değer olarak ayarlayabilirsiniz */}
      <label htmlFor="Min Stock" className="font-medium">{"Min Stock"}</label>
      <InputNumber 
        inputId="minPax"
        value={minPax} 
        onValueChange={(e) => setMinPax(e.value)}
        className="h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
        
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxPax" className="font-medium block">{"Max Stock"}</label>
      <InputNumber 
        inputId="maxPax"
        value={maxPax} 
        onValueChange={(e) => setMaxPax(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className=" mr-2 ml-2">
      <label htmlFor="minAdl" className="font-medium block">Nofication Stock</label>
      <InputNumber 
        inputId="minAdl"
        value={minAdl} 
        onValueChange={(e) => setMinAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
  </div>

  <div className="col-span-1">
    <div className="mr-2 ml-2">
      <label htmlFor="maxAdl" className="font-medium block">Auto Order</label>
      <InputNumber 
        inputId="maxAdl"
        value={maxAdl} 
        onValueChange={(e) => setMaxAdl(e.value)}
        className="w-full h-11 border-gray-300 rounded-md"
        inputStyle={{ width: "90%" }}
      />
    </div>
    
    
  </div>

 
</div>





    <div className="mt-4 flex justify-end">
    <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={onClicktax2}
      >
        {'Add Tax'}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleinsert}
      >
        {create_room_typerec}
      </button>
    </div>
  </div>

  <Dialog visible={displayBasic} style={{ width: '60vw' }} onHide={onHide} header={room_person_factor_title}>
  <div className={`modal-backdrop bg-slate-600  ${displayBasic ? 'block' : 'hidden'}`}></div>
  <div>
    <p>
    <HtlRoomFactor/>
    </p>
  </div>
</Dialog>


<TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Product Tax Detail"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>
  

      <DataTable
         value={firmData2}
         scrollable 
         scrollHeight="250px" 
       //  loading={loadingRuleSub}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >

          <Column field="acc_ent_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rule Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

           <Column field="acc_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rule Id"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
        

          <Column field="acc_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Type"}</span>}
           style={{ textAlign: 'left', width: '9rem' }}
          >
          </Column>
          <Column field="acc_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="source_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="source_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="opr_filter"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="opr_filter_gnl"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>

          <Column field="card_value"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Rules Desc"}</span>}
           style={{ textAlign: 'left', width: '15rem' }}
          >
          </Column>
  
  
         

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{"statusrec"}</span>}
            style={{ textAlign: 'center', width: '6rem' }}
            className="font-bold text-sm" 
          />
          <Column
          header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode8(rowData.acc_id);  
                setVarCode10(rowData.acc_type); 
                setVarCode9(rowData.acc_code); 
                
                setVarCode13(rowData.acc_ent_id); 
             
            onClicktax();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable>

   {/* Dialog penceresi */}
   <Dialog header={"Tax Detail"} visible={displayBasictax} style={{ width: '55vw' }} onHide={onHidetax}>
   
       <div>

       <HtlProdTaxEdit/>
      
       </div>
     
   </Dialog>
 </div>

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Product Department Detail"}
            </span>
          }
          className="ml-5 flex"
        >
    
           

              </TabPanel>

              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Product Accounting Cards"}
            </span>
          }
          className="ml-5 flex"
        >
    
           

              </TabPanel>
            
          </TabView>

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Product Departments"}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Product Account Cards"}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

  

  

  <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 4 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {<FormattedMessage id="room_type_departments_title" />}
            </span>
          }
          className="ml-5 flex"
        >
            "dsjkdjsldjsl"

  </TabPanel>

</TabView>
  </div>
  </div>
);
};

export default HtlProdStockCardEditDialog;
